<section class="solutions-section">
    <div class="container">
        <div class="section-header text-center mb-5">
            <h2 class="section-title">Tailored <span>Solutions</span></h2>
            <div class="title-underline"></div>
        </div>

        <div class="solutions-grid">
            <div class="solution-card" *ngFor="let solution of solutions">
                <div class="solution-image-wrapper">
                    <img [src]="solution.image" [alt]="solution.title" class="solution-img">
                </div>
                <div class="card-content">
                    <h3 class="solution-title">{{ solution.title }}</h3>
                    <p class="solution-description">{{ solution.description }}</p>
                    <a [routerLink]="solution.link" class="view-solution-btn">
                        <span>View Solution</span>
                        <mat-icon>arrow_forward</mat-icon>
                    </a>
                </div>
                <div class="card-gradient"></div>
            </div>
        </div>
    </div>
</section>